var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-import-page"},[_c('ContactImportUpload',{attrs:{"override-import-type":'contact',"pageCopy":_vm.page_copy,"fieldDefinitions":_vm.field_definitions,"previewConfig":_vm.preview_config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }